import { Box, styled, Typography } from "@mui/material";
import FrontImage from "@/../public/img/ranvet/widget-front.png";
import Image from "next/image";
import LogoImage from "@/../public/img/ranvet/logo-without-tagline.png";
import BackImage from "@/../public/img/ranvet/widget-back.png";
import { useState } from "react";
import PillButton from "@/app/shared/PillButton";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

const WIDTH = 185;

const Stage = styled(Box)({
  width: WIDTH,
  height: 365,
  perspective: 1000,
});

const Card = styled(Box)({
  position: "relative",
  width: "100%",
  height: "100%",
  cursor: "pointer",
  transformStyle: "preserve-3d",
  transition: "transform 0.8s cubic-bezier(0.65,0.05,0.36,1)",
  "&.flipped": {
    transform: "rotateY(180deg)",
  },
});

const Face = styled(Box)(({ theme }) =>
  theme.unstable_sx({
    width: "100%",
    height: "100%",
    backfaceVisibility: "hidden",
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    alignItems: "center",
    padding: 1,
    paddingTop: 2,
    whiteSpace: "nowrap",
    border: "1px solid",
    borderColor: "grey.300",
    borderRadius: 2,
    justifyContent: "center",
    cursor: "pointer",
    "&.back": {
      transform: "rotateY(180deg)",
    },
  }),
);

function CardLabel() {
  return (
    <Typography
      sx={{
        backgroundColor: "white",
        position: "absolute",
        top: -12,
        left: "50%",
        transform: "translateX(-50%)",
        padding: "2px 6px",
        fontWeight: "bold",
      }}
      variant="caption"
    >
      Nutrition
    </Typography>
  );
}

const CardText = styled(Typography)({
  textAlign: "center",
  whiteSpace: "normal",
  lineHeight: 1.3,
});

export function AdNutritionWidget() {
  const [isFlipped, setIsFlipped] = useState(false);
  return (
    <Stage>
      <Card
        className={`card ${isFlipped ? "flipped" : ""}`}
        onClick={() => setIsFlipped(!isFlipped)}
      >
        <Face className="front">
          <CardLabel />
          <Image
            src={FrontImage}
            alt="Nutrition Widget Front"
            width={WIDTH - 2}
          />
          <Image src={LogoImage} alt="Nutrition Widget Logo" width={150} />
          <Typography
            variant="caption"
            sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
          >
            <SwapHorizIcon />
            Tap to Flip
          </Typography>
        </Face>
        <Face className="back">
          <CardLabel />
          <CardText
            variant="caption"
            sx={{
              fontWeight: "bold",
            }}
          >
            EVERY GREAT SECOND CAREER STARTS WITH THE RIGHT SUPPORT
          </CardText>
          <Image src={BackImage} alt="Nutrition Widget Back" width={160} />
          <CardText variant="caption">
            Everything you need to transition your thoroughbred from the
            racetrack to a healthy second career. Follow a phase-by-phase
            feeding plan, discover the right Ranvet supplements, and get expert
            advice on caring for your off-the-track horse.
          </CardText>
          <a href="/hub/ranvet.html" target="_blank" rel="noopener noreferrer">
            <PillButton
              primary
              sx={{
                backgroundColor: "#da291c",
                whiteSpace: "normal",
                lineHeight: 1.2,
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              OFF THE TRACK HEALTH HUB
            </PillButton>
          </a>
        </Face>
      </Card>
    </Stage>
  );
}
